import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import onClickOutside from 'react-onclickoutside';
import { translate } from 'react-i18next';

import i18n from '../../../i18n';

@connect(
  state => ({
    currentLanguage: state.langs.currentLanguage,
  }),
)
@translate(['common'], { wait: true })
@onClickOutside
export class Languages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleLanguageChange = (e, lang) => {
    e.preventDefault();
    if (!this.state.open) {
      this.setState({
        open: true,
      });
    } else {
      i18n.changeLanguage(lang);
      this.setState({
        open: false,
      });
    }
  };

  handleClickOutside = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const currentLanguage = this.props.currentLanguage;

    return (
      <div
        className={cx({
          'lang-list-wrap': true,
          'open-lang-list': this.state.open,
        })}
      >
        <ul className="lang-list">
          <li className={cx({ active: currentLanguage === 'pt' })}>
            <a
              role="presentation"
              onClick={e => this.handleLanguageChange(e, 'pt')}
            >
              <span className="flag flag-pt" />Pt
            </a>
          </li>
          <li className={cx({ active: currentLanguage === 'en' })}>
            <a
              role="presentation"
              onClick={e => this.handleLanguageChange(e, 'en')}
            >
              <span className="flag flag-en" />Eng
            </a>
          </li>
          <li className={cx({ active: currentLanguage === 'fr' })}>
            <a
              role="presentation"
              onClick={e => this.handleLanguageChange(e, 'fr')}
            >
              <span className="flag flag-fr" />Fra
            </a>
          </li>
          <li className={cx({ active: currentLanguage === 'de' })}>
            <a
              role="presentation"
              onClick={e => this.handleLanguageChange(e, 'de')}
            >
              <span className="flag flag-de" />Ger
            </a>
          </li>
          <li className={cx({ active: currentLanguage === 'ru' })}>
            <a
              role="presentation"
              onClick={e => this.handleLanguageChange(e, 'ru')}
            >
              <span className="flag flag-ru" />Рус
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

Languages.WrappedComponent.propTypes = {
  currentLanguage: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarFooter/Languages.js